// playMelodicNotification.ts

let audioCtx: AudioContext | null = null

/**
 * Создаёт или возвращает существующий AudioContext.
 * Разблокирует его, если он в состоянии 'suspended'.
 */
const getAudioContext = (): AudioContext | null => {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)()
  }

  // Попытка разблокировать контекст
  if (audioCtx.state === 'suspended') {
    audioCtx.resume().catch(() => {
      // если пользователь ещё не взаимодействовал с сайтом,
      // звук не проиграется, но ошибок не будет
    })
  }

  return audioCtx
}

/**
 * Функция для воспроизведения короткого мелодичного уведомления
 */
export const playMelodicNotification = () => {
  const ctx = getAudioContext()
  if (!ctx) return // если ещё нет взаимодействия пользователя, не проигрываем

  const notes = [
    { freq: 1200, time: 0 },    // первая нота
    { freq: 1600, time: 0.13 }, // вторая нота
    { freq: 1400, time: 0.26 }, // третья нота
  ]

  notes.forEach(({ freq, time }) => {
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()

    osc.type = 'triangle' // мягче, но заметно
    osc.frequency.setValueAtTime(freq, ctx.currentTime + time)

    // плавный нарастающий пик и затухание
    gain.gain.setValueAtTime(0, ctx.currentTime + time)
    gain.gain.linearRampToValueAtTime(0.35, ctx.currentTime + time + 0.02)
    gain.gain.linearRampToValueAtTime(0, ctx.currentTime + time + 0.12)

    osc.connect(gain)
    gain.connect(ctx.destination)

    osc.start(ctx.currentTime + time)
    osc.stop(ctx.currentTime + time + 0.12)
  })
}

/**
 * Опционально: разблокировка AudioContext после первого клика
 * Нужно вызвать один раз в React, чтобы уведомления всегда работали
 */
export const unlockAudio = () => {
  const ctx = getAudioContext()
  if (ctx?.state === 'suspended') {
    ctx.resume()
  }
}